import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import TextInput from "../../common/form/TextInput";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";
import {getAutocompleteSiteAnnouncements} from "../../common/util/helpers";
import {useSelector} from "react-redux";
import {selectedSiteSelector} from "../../authentication/redux";

type Props = {
    index: number
    control: Control<any>
}


export const WelcomeMessageForm = ({ index, control }: Props) => {
    const { t } = useTranslation()

    const site = useSelector(selectedSiteSelector)

    const welcomeMessageOptionParams = useMemo(() => {
        return getAutocompleteSiteAnnouncements(t, 2000, site)
    }, [site, t])

    return (<FormRow>
        <FormFieldBox>
            <TextInput
                help={t('general.max-file-size', {size: 2})}
                readonly={false}
                label={t('flows.edit.welcome-message')}
                name={`fieldUpdates.${index}.values.0.stringValue`}
                control={control}
                required={false}
                autoCompleteOptions={welcomeMessageOptionParams}
            />
        </FormFieldBox>
    </FormRow>)
}